import React from "react";

// Components
import { withTranslation } from "react-i18next";
import ModalConfirmation from "../../../components/Modals/ModalConfirmation";

// Styles
import "../../../components/Inputs/Input.scss";
import "./AccountBlocked.scss";

class ResetPassword extends React.Component<any, any> {
  constructor(props: any, context: any) {
    super(props, context);

    this.state = {
      loading: false,
      confirmationModalOpen: false,
    };
  }

  cancel() {}

  render() {
    const { t } = this.props;
    const isMobile = window.innerWidth < 992;

    return (
      isMobile && (
        <ModalConfirmation
          isOpen={this.props.isOpen}
          closeModal={this.props.closeModal}
          heading={t("accountBlocked")}
          classModifiers={"account-blocked"}
          buttons={[{ text: t("close"), onClick: this.props.closeModal, className: "button--wire-white" }]}
        />
      )
    );
  }
}

export default withTranslation()(ResetPassword);
